import request from '../../utils/request';

export default () => request('/ala-agreements');
